import { render, staticRenderFns } from "./AppLink.vue?vue&type=template&id=07b38c2e&scoped=true"
import script from "./AppLink.vue?vue&type=script&setup=true&lang=js"
export * from "./AppLink.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AppLink.vue?vue&type=style&index=0&id=07b38c2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b38c2e",
  null
  
)

export default component.exports